var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"food-service"}},[_c('food-hero'),_c('food-categories'),_c('food-how-it-works'),_c('foravila-guarantee')],1)}
var staticRenderFns = []

export { render, staticRenderFns }